import axios from 'axios';

let baseURLStr = window.g.ApiUrl;
axios.defaults.baseURL = baseURLStr;

//请求拦截器
axios.interceptors.request.use(config => {
    return config
});

//相应拦截器
axios.interceptors.response.use(response => {
    return response.data;
});

export default axios

// 查询
export let postCertQuery = (params) => {
    return axios.post(`api/PrintCert/GetCert`, params)
};



// WEBPACK FOOTER //
// ./src/api/index.js